<template>
  <div class="circle-progress">
    <canvas id="canvas" :width="width" :height="height" :style="{ width: width + 'px', height: height + 'px' }"></canvas>
    <div class="progress-text">
      <slot />
    </div>
  </div>
</template>

<script>
// 比例 4*18 + '/' + 5*18 + '/' + 5*18*2
export default {
  name: 'CircleProgress',
  props: {
    showText: Boolean,
    value: Number,
    sum: Number,
    width: {
      type: Number,
      default: 175
    },
    height: {
      type: Number,
      default: 175
    }
  },
  data() {
    return {
      canvas: '',
      percent: '',
      ctx: '',
      circleX: '',
      circleY: '',
      radius: '',
      cradius: '',
      lineWidth: '',
      fontSize: '',
      color: '',
      process: '',
      circleLoading: null,
      switcha:true,
    };
  },
  watch: {
    value(newVal, oldVal) {
      console.log('newVal',newVal,'oldVal',oldVal)
      if(!oldVal && !this.sum){
        if(this.switcha){
          this.toCanvas('canvas', '#ffbf00', this.value);
        }
      }
    },
    sum(newVal, oldVal) {
      console.log('newVal value',newVal,'oldVal',oldVal)
      if(!oldVal && !this.value){
        this.toCanvas('canvas', '#ffbf00', this.sum);
      }
    }
  },
  mounted() {
    console.log('value',this.value)
    const id = 'canvas'
    this.canvas = document.getElementById(id);
    this.setCanvasPixelRatio()
  },
  activated() {
    this.$nextTick(() => {
      // this.value = 0 // test
     if(this.value){
       this.switcha=false;
        this.toCanvas('canvas', '#ffbf00', this.value);//会跟watch冲突
       }
    })
  },
  methods: {
    setCanvasPixelRatio() {
      const { canvas } = this

      // 获取到屏幕倒是是几倍屏。
      const getPixelRatio = function(context) {
        var backingStore = context.backingStorePixelRatio ||
          context.webkitBackingStorePixelRatio ||
          context.mozBackingStorePixelRatio ||
          context.msBackingStorePixelRatio ||
          context.oBackingStorePixelRatio ||
          context.backingStorePixelRatio || 1;
        return (window.devicePixelRatio || 1) / backingStore;
      };
      // iphone6下得到是2
      const pixelRatio = getPixelRatio(canvas);
      this.pixelRatio = pixelRatio // 当前是几倍屏
    
      // 设置canvas的真实宽高
      canvas.width = pixelRatio * canvas.offsetWidth; // 想当于 2 * 375 = 750 
      canvas.height = pixelRatio * canvas.offsetHeight;
    },
    getRadiusSize() {
      const width = this.width * this.pixelRatio
      const size = width / 10
      return {
        radius: 4 * size,
        cradius: 5 * size,
        width// 5 * 18 * 2
      }
    },
    // 两端圆点
    smallcircle1(cx, cy, r) {
      this.ctx.beginPath();
      // this.ctx.moveTo(cx + r, cy);
      this.ctx.lineWidth = 1;
      this.ctx.fillStyle = '#7f8387';
      this.ctx.arc(cx, cy, r, 0, Math.PI * 2);
      this.ctx.fill();
    },
    smallcircle2(cx, cy, r) {
      this.ctx.beginPath();
      // ctx.moveTo(cx + r, cy);
      this.ctx.lineWidth = 1;
      this.ctx.fillStyle = '#7f8387';
      this.ctx.arc(cx, cy, r, 0, Math.PI * 2);
      this.ctx.fill();
    },
    // 画圆
    circle(cx, cy, r) {
      this.ctx.beginPath();
      // ctx.moveTo(cx + r, cy);
      this.ctx.lineWidth = this.lineWidth;
      this.ctx.strokeStyle = '#7f8387';
      this.ctx.arc(cx, cy, r, (Math.PI * 2) / 3, (Math.PI * 1) / 3);
      this.ctx.stroke();
    },
    // 画弧线
    sector(cx, cy, r, startAngle, endAngle, anti) {
      this.ctx.beginPath();
      // ctx.moveTo(cx, cy + r); // 从圆形底部开始画
      this.ctx.lineWidth = this.lineWidth;
      // 进度条颜色
      this.ctx.strokeStyle = this.color;
      // 圆弧两端的样式
      this.ctx.lineCap = 'round';
      // 圆弧
      this.ctx.arc(cx, cy, r, (Math.PI * 2) / 3, (Math.PI * 2) / 3 + (endAngle / 100) * ((Math.PI * 5) / 3), false);
      this.ctx.stroke();
    },
    // 刷新
    loading(progress) {
      if (this.process >= this.percent) {
        clearInterval(this.circleLoading);
      }
      // 清除canvas内容
      this.ctx.clearRect(0, 0, this.circleX * 2, this.circleY * 2);
      // 中间的字
      this.ctx.font = this.fontSize + 'px April';
      this.ctx.textAlign = 'center';
      this.ctx.textBaseline = 'middle';
      this.ctx.fillStyle = '#999';
      if (this.showText) {
        const text = ''
        this.ctx.fillText(text, this.circleX, this.circleY);
      }
      // 圆形
      this.circle(this.circleX, this.circleY, this.radius);
      // 圆弧
      this.sector(this.circleX, this.circleY, this.radius, (Math.PI * 2) / 3, this.process);
      // 两端圆点
      this.smallcircle1(
        this.cradius + Math.cos(((2 * Math.PI) / 360) * 120) * this.radius,
        this.cradius + Math.sin(((2 * Math.PI) / 360) * 120) * this.radius,
        0
      );
      this.smallcircle2(
        this.cradius +
          Math.cos(((2 * Math.PI) / 360) * (120 + this.process * 3)) * this.radius,
        this.cradius +
          Math.sin(((2 * Math.PI) / 360) * (120 + this.process * 3)) * this.radius,
        2
      );
      // 控制结束时动画的速度
      if (this.process / this.percent > 0.9) {
        this.process += 0.3;
      } else if (this.process / this.percent > 0.8) {
        this.process += 0.55;
      } else if (this.process / this.percent > 0.7) {
        this.process += 0.75;
      } else {
        this.process += 1.0;
      }
    },
    /** 生成环形进度条 **/
    toCanvas(id, color, progress) {
      const { radius, cradius } = this.getRadiusSize()
      const canvas = this.canvas
      this.percent = progress // 最终百分比
      this.ctx = canvas.getContext('2d');
      this.circleX = canvas.width / 2; // 中心x坐标
      this.circleY = canvas.height / 2; // 中心y坐标
      this.radius = radius; // 圆环半径
      this.cradius = cradius; // canvas半径
      this.lineWidth = 7 * this.pixelRatio; // 圆形线条的宽度
      this.fontSize = 20 * this.pixelRatio; // 字体大小
      this.process = 0; // 进度
      this.color = color;
      this.circleLoading = window.setInterval(() => {
        this.loading(progress);
      }, 20);
    }
  }
};
</script>
<style lang="scss" scoped>
.circle-progress {
  width: 175px;
  height: 175px;
  .progress-text {
    position: relative;
    top: -125px;
  }
}
</style>
